import dayjs from 'dayjs';
import { t } from 'i18next';

/* eslint-disable import/prefer-default-export */
export const modifiedData = (dataProject: any[]) => {
  return dataProject && dataProject.length > 0
    ? dataProject?.map((item: any) => {
        let assignmentStatus = 'Will Require assign';
        let icon = 'awaiting';
        let tooltip = 'Unassigned dates after ten days';
        let priorityIcon = 'lowPriority';

        if (
          item?.assignments?.requiredMore10Days > 0 &&
          item?.assignments?.requiredMore10Days >
            item?.assignments?.assignedMore10Days
        ) {
          assignmentStatus = 'Will Require assign';
          tooltip = 'Unassigned dates after ten days';
          priorityIcon = 'lowPriority';
          icon = 'awaiting';
        }

        if (
          item?.assignments?.requiredLess10Days > 0 &&
          item?.assignments?.requiredLess10Days >
            item?.assignments?.assignedLess10Days
        ) {
          assignmentStatus = 'Required assign';
          icon = 'warning';
          tooltip = 'Unassigned dates in the next ten days';
          priorityIcon = 'mediumPriority';
        }

        if (
          item?.assignments?.required3Days > 0 &&
          item?.assignments?.required3Days > item?.assignments?.assigned3Days
        ) {
          assignmentStatus = 'Urgent Required assign';
          priorityIcon = 'highPriority';
          icon = 'rejected';
          tooltip = 'Unassigned dates in the next three days';
        }

        if (
          (item?.assignments?.requiredMore10Days > 0 ||
            item?.assignments?.requiredLess10Days > 0 ||
            item?.assignments?.required3Days > 0) &&
          (item?.assignments?.required3Days === 0 ||
            item?.assignments?.required3Days ===
              item?.assignments?.assigned3Days) &&
          (item?.assignments?.requiredLess10Days === 0 ||
            item?.assignments?.requiredLess10Days ===
              item?.assignments?.assignedLess10Days) &&
          (item?.assignments?.requiredMore10Days === 0 ||
            item?.assignments?.requiredMore10Days ===
              item?.assignments?.assignedLess10Days)
        ) {
          assignmentStatus = 'All assigned';
          icon = 'approved';
          tooltip = 'All dates assigned';
        }
        if (item?.status?.toLowerCase() === 'cancelled') {
          assignmentStatus = 'Not required';
          icon = 'notRequired';
          priorityIcon = 'notRequired';
          tooltip = '';
        }

        const client =
          item?.clientCompanyName && item?.clientCompanyName !== ''
            ? item?.clientCompanyName
            : `${item?.clientFirstName} ${item?.clientLastName}`;
        return {
          ...item,
          assignmentStatus,
          client,
          icon,
          leadProjectEndDate: dayjs(item.leadProjectEndDate).format(
            'MM-DD-YYYY'
          ),
          leadProjectStartDate: dayjs(item.leadProjectStartDate).format(
            'MM-DD-YYYY'
          ),
          priorityIcon,
          priorityText: t(`STATUS.${priorityIcon}`),
          tooltip
        };
      })
    : [];
};
